import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import { useFilterContext } from "../../../hooks/FilterContext";
import { Button } from "../../../components";
import { DateInput, FormSelect } from "../../../components/forms";
import FeeTypeFormSelect from "../../headofficefeemanagement/components/FeeTypeFormSelect";

export const HeadOfficeAgedDebtorManagementModal = ({ handleClose, onFiltersChanged, show, currentSearchType, ...rest }) => {

    const { defaultFilters, filter, setFilter } = useFilterContext();
    const [tempFilters, setTempFilters] = useState(filter);
    const onApplyFilters = () => {
        setFilter(original => {
            return {
                ...original,
                ...tempFilters
            }
        });
        onClose();
    };

    const onClearFilters = () => {
        setTempFilters(_ => defaultFilters);
    };

    const onFilterValueChanged = (property, value) => {
        setTempFilters(original => {
            return {
                ...original,
                [property]: value
            };
        });
    };

    const onClose = () => {
        if (handleClose && typeof (handleClose) === 'function') {
            handleClose();
        }
    };

    useEffect(() => {
        if (!_.isEqual(filter, tempFilters)) {
            setTempFilters(_ => filter);
        }
    }, [filter]);

    return <Modal size="lg" centered backdrop="static" show={show}>
        <Modal.Header>Debtor Management Filters</Modal.Header>
        <Modal.Body {...rest}>
            <HeadOfficeAgedDebtorManagementFilters
                filter={tempFilters}
                setFilter={onFilterValueChanged}
                currentSearchType = {currentSearchType}
            />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="warning" onClick={onClearFilters}>Clear Filters</Button>
            <Button variant="success" onClick={onApplyFilters}>Apply Filters</Button>
            <Button variant="light" onClick={onClose}>Cancel</Button>
        </Modal.Footer>
    </Modal>
};

const HeadOfficeAgedDebtorManagementFilters = ({ filter, setFilter, currentSearchType }) => {

    const {
        fromDate,
        toDate,
        feeTypes
    } = filter || {};

    return <React.Fragment>
            <div className="row mb-3">
                <div className="col">
                    <DateInput
                        label={"From Date"}
                        placeholder="From Date"
                        isClearable
                        disableAnimations={true}
                        value={fromDate}
                        onBlur={(value, _) => setFilter('fromDate', value)}
                    />
                </div>
                <div className="col">
                    <DateInput
                        label={"To Date"}
                        placeholder="To Date"
                        isClearable
                        disableAnimations={true}
                        value={toDate}
                        onBlur={(value, _) => setFilter('toDate', value)}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <FeeTypeFormSelect
                        label={"Fee Types"}
                        isMulti={true}
                        defaultValue={feeTypes}
                        onChange={(values) => setFilter("feeTypes", values.map(x => x.value))}
                    /> 
                </div>
            </div>

    </React.Fragment>


};

export default HeadOfficeAgedDebtorManagementFilters;